const ellipsisContent = (content, len = 100) => {
  let text = '';
  let htmlReg = new RegExp('<[^<>]+>','g');
  let pureText= content.replace(htmlReg,'');

  if (pureText){
    len = pureText.length < len ? pureText.length : len;
    text = pureText.substring(0,len)+'...';
  }
  
  text.trim();

  return text;
}

export default ellipsisContent